import { styled } from '@goodfynd/theme';

export const StyledEmbedContainer = styled('div', {
  position: 'relative',
});

export const StyledFiltersContainer = styled('div', {
  display: 'flex',
  flexWrap: 'wrap',
  gap: 8,
  left: 0,
  margin: '8px 8px 0',
  position: 'absolute',
  top: 0,
  zIndex: 1,
});

export const StyledLoadMoreContainer = styled('section', {
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  padding: '1rem 0',
  '@mdMax': {
    padding: 0,
  },
});
